/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityLookalikesSslValidity
 */
export interface ControlEntityLookalikesSslValidity {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslValidity
     */
    not_after?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityLookalikesSslValidity
     */
    not_before?: string;
}

/**
 * Check if a given object implements the ControlEntityLookalikesSslValidity interface.
 */
export function instanceOfControlEntityLookalikesSslValidity(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityLookalikesSslValidityFromJSON(json: any): ControlEntityLookalikesSslValidity {
    return ControlEntityLookalikesSslValidityFromJSONTyped(json, false);
}

export function ControlEntityLookalikesSslValidityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityLookalikesSslValidity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'not_after': !exists(json, 'not_after') ? undefined : json['not_after'],
        'not_before': !exists(json, 'not_before') ? undefined : json['not_before'],
    };
}

export function ControlEntityLookalikesSslValidityToJSON(value?: ControlEntityLookalikesSslValidity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'not_after': value.not_after,
        'not_before': value.not_before,
    };
}

